export const toMaxTwoFixedNumber = (v: number) => +v.toFixed(2);
